export function setSubscriptionData(userId: string) {
  localStorage.setItem('subscriptionData', userId);
}

export function getSubscriptionData(): string | null {
  return localStorage.getItem('subscriptionData');
}

export function deleteSubscriptionData() {
  localStorage.removeItem('subscriptionData');
}
